export const PRICE_LADDER_CONFIG = {
  MIN_PRICE: 1.01,
  MAX_PRICE: 1000,
  STEPS: [
    { minimum: 1.01, increment: 0.01 },
    { minimum: 2, increment: 0.02 },
    { minimum: 3, increment: 0.05 },
    { minimum: 4, increment: 0.1 },
    { minimum: 6, increment: 0.2 },
    { minimum: 10, increment: 0.5 },
    { minimum: 20, increment: 1 },
    { minimum: 30, increment: 2 },
    { minimum: 50, increment: 5 },
    { minimum: 100, increment: 10 },
  ],
};

/**
 * The steps of the FINEST ladder, which Asian Handicaps are quoted on: one 0.01 step across the whole range,
 * so a price between two CLASSIC ticks (2.13) is valid. Same range as the default, and the same steps as
 * EMS's FINEST ladder (`bet-engine-2.config.js`).
 */
export const FINEST_PRICE_LADDER_STEPS = [{ minimum: 1.01, increment: 0.01 }];

export const MATCH_ME_CONFIG = [
  { minimum: 1, deviation: 0 },
  { minimum: 1.1, deviation: 5 },
];

export const SIZE_LADDER_CONFIG = {
  MAX_SIZE: 999999999,
  INTERVAL: 0.01,
};

export const SIZE_NUDGE_STEP = 1;

export const LADDER_DEFAULT_MIN_SIZE = 1;
